var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_c"},[_c('p',{staticClass:"news_c_title"},[_vm._v(_vm._s(_vm.news.title))]),_c('div',{staticClass:"news_c_text",domProps:{"innerHTML":_vm._s(_vm.news.contents)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }